import React from 'react'
import ReactDOM from 'react-dom'
import {Button} from '@thryvlabs/maverick'

/**
 *
 * @param {{
 *   url: string;
 *   title: string;
 *   open: boolean;
 *   onClose: ()=>void;
 *   redirectUrl?: string;
 * }} props
 */
export function ToolItemModal(props) {
  if (!props.open) return null

  // The app tracks its left nav width in the --sidebar-width custom property (see global.css)
  const getSidebarWidth = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(
      '--sidebar-width',
    )
    return parseInt(value) || 0
  }

  const sidebarWidth = getSidebarWidth()

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: sidebarWidth,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2147483000,
  }

  // if (props.redirectUrl) {
  //   return ReactDOM.createPortal(
  //     <div
  //       style={{
  //         ...overlayStyle,
  //         display: 'flex',
  //         flexDirection: 'column',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //       }}
  //     >
  //       <div
  //         style={{
  //           position: 'relative',
  //           background: '#fff',
  //           borderRadius: '8px',
  //           width: '95%',
  //           height: '85%',
  //           display: 'flex',
  //           flexDirection: 'column',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //           textAlign: 'center',
  //         }}
  //       >
  //         <Button
  //           variant="primary"
  //           onClick={props.onClose}
  //           style={{position: 'absolute', top: '12px', right: '12px'}}
  //         >
  //           Close
  //         </Button>
  //         <p style={{fontSize: '18px', margin: 0}}>
  //           The Client Testimonial Library is now available in the Learning Hub.{' '}
  //           <a href={props.redirectUrl} target="_blank" rel="noreferrer">
  //             Go to the Learning Hub
  //           </a>
  //         </p>
  //       </div>
  //     </div>,
  //     document.body,
  //   )
  // }

  // Embed full external URLs (e.g. Benchmarking Tool) as-is; resolve relative
  // collateral paths (e.g. "product-leave-behinds") against the collateral host.
  const isAbsoluteUrl = /^https?:\/\//i.test(props.url)
  const URL = isAbsoluteUrl
    ? props.url
    : `${process.env.REACT_APP_OOE_TOOLS_URL}/${props.url}`
  return ReactDOM.createPortal(
    <div
      style={{
        ...overlayStyle,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '95%',
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#fff',
            padding: '10px 16px',
          }}
        >
          <span style={{fontWeight: '600', fontSize: '16px'}}>
            {props.title}
          </span>
          <Button variant="primary" onClick={props.onClose}>
            Close
          </Button>
        </div>
        <iframe
          title={props.title}
          id={props.url}
          src={URL}
          width="100%"
          style={{flex: 1, display: 'block', border: 'none'}}
        />
      </div>
    </div>,
    document.body,
  )
}
